import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TrabalheConosco from './pages/TrabalheConosco';
import TrabalheConoscoCompletar from './pages/TrabalheConoscoCompletar';
import TrabalheConoscoDisponibilidade from './pages/TrabalheConoscoDisponibilidade';
import ChatPlugin from './ChatPlugin';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
        <Route path="/trabalhe-conosco/completar/:candidate/:token" element={<TrabalheConoscoCompletar />} />
        <Route path="/trabalhe-conosco/disponibilidade/:candidate/:token" element={<TrabalheConoscoDisponibilidade />} />
      </Routes>
      <ChatPlugin />
    </>
  );
}

export default App;
